import { useAppDispatch, useAppSelector } from '../../../../configuration/setup/hooks';
import { getSortingForCategory, transportAssignmentsSlice } from '../../reducers/transportAssignmentsSlice';
import { AppTableCardsSorting } from '../../sharedComponents/table/AppTableCardsSorting';
import { ColumnDefinition, TableSort } from '../../sharedComponents/table/SortedTableHeader';
import { TransportAssignmentTableColumn } from './TransportAssignmentTableColumns';
import { TableCategory } from '../tableCategory.types';

export const TransportAssignmentsCardsSorting = ({
    category,
    columnDefinition,
}: {
    category: TableCategory;
    columnDefinition: ColumnDefinition<TransportAssignmentTableColumn>[];
}) => {
    const dispatch = useAppDispatch();
    const sorting = useAppSelector(getSortingForCategory(category));

    return (
        <AppTableCardsSorting
            columnDefinition={columnDefinition}
            sorting={sorting}
            setSorting={(sort: TableSort<TransportAssignmentTableColumn>) =>
                dispatch(
                    transportAssignmentsSlice.actions.setSortingForCategory({
                        category,
                        sort,
                    }),
                )
            }
        />
    );
};
